<template>
  <div>
    <MobileHeader active="solution"></MobileHeader>

    <el-row>
      <h1>解决方案</h1>
    </el-row>
    <div class="title">
      <div
        v-bind:class="{ click: index == 1 }"
        class="title1"
        v-on:click="click(1)"
      >
        自主解决方案
      </div>
      <div
        v-bind:class="{ click: index == 2 }"
        class="title1"
        v-on:click="click(2)"
      >
        合作解决方案
      </div>
    </div>

    <div v-if="index == 1">
      <div
        v-for="item in solutionArray"
        v-bind:key="item.id"
        style="padding-top: 10px; margin-bottom: 40px"
      >
        <div style="position: relative">
          <div style="position: relative">
            <img :src="item.img" style="width: 100%; height: auto" />
          </div>
          <!--<div class="san1">-->
          <!--<div class="cuIcon-triangleupfill lg text-white"></div>-->
          <!--</div>-->
        </div>
        <div class="">
          <div class="" style="margin: 10px 20px 10px 20px">
            <div>
              <h2 class="" v-html="item.title"></h2>
            </div>
          </div>
        </div>
        <div style="margin: 0px 20px 0px 20px" >
          <div class="business-content">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="index == 2">
      <div
        v-for="item in solutionArray1"
        v-bind:key="item.id"
        style="padding-top: 10px; margin-bottom: 40px"
      >
        <div style="position: relative">
          <div style="position: relative">
            <img :src="item.img" style="width: 100%; height: auto" />
          </div>
          <!--<div class="san1">-->
          <!--<div class="cuIcon-triangleupfill lg text-white"></div>-->
          <!--</div>-->
        </div>
        <div class="">
          <div class="" style="margin: 10px 20px 10px 20px">
            <div>
              <h2 class="" v-html="item.title"></h2>
            </div>
          </div>
        </div>
        <div style="margin: 0px 20px 20px 20px">
          <div class="business-content">
            {{ item.content }}
          </div>
        </div>
        <div v-if="item.isK" style="display: inline-block;width:100%;">
     <div class="div"><img class="img" src="https://www.ccsht.cn/resources/static/images/2.png" ></div>
    <div class="div"><img class="img" src="https://www.ccsht.cn/resources/static/images/3.png"  ></div>
    <div class="div"><img class="img"  src="https://www.ccsht.cn/resources/static/images/4.png" ></div>
    <div class="div"><img class="img"  src="https://www.ccsht.cn/resources/static/images/1.png"  ></div>
</div>

<div v-if="item.isB">
    <div class="text-center" style="width:100%;font-size:1rem">
      <div>
        <img src="https://www.ccsht.cn/resources/static/images/toG.png" style="width:70vw;height:26vh;">
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;	border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">数字政府</div>
        <div class="padding-bottom-xs ">数字政府大数据平台建设</div>
        <div class="padding-bottom-xs ">政府数据治理&融合分析</div>
        <div class="padding-bottom-xs ">城市大脑&智慧城市</div>
        <div class="padding-bottom-xs ">领导驾驶舱</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">智慧应急</div>
        <div class="padding-bottom-xs ">应急大数据治理</div>
        <div class="padding-bottom-xs ">危化品安全生产管理</div>
        <div class="padding-bottom-xs ">防汛防台预警预防</div>
        <div class="padding-bottom-xs ">智慧消防一体化平台</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">智慧环保</div>
        <div class="padding-bottom-xs ">生态环境全景数据库</div>
        <div class="padding-bottom-xs ">网格化精细监测与智能决策</div>
        <div class="padding-bottom-xs ">基于深度学习的预测溯源</div>
        <div class="padding-bottom-xs ">区域生态环境动态管控</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">公共安全</div>
        <div class="padding-bottom-xs ">公安大数据治理</div>
        <div class="padding-bottom-xs ">案件数字化侦查与分析</div>
        <div class="padding-bottom-xs ">社会治安风险防控</div>
        <div class="padding-bottom-xs ">智能警务服务</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">海外</div>
        <div class="padding-bottom-xs ">全媒体智能洞察与分析</div>
        <div class="padding-bottom-xs ">网络安全智能分析</div>
        <div class="padding-bottom-xs ">政务信息化与政府决策</div>
        <div class="padding-bottom-xs ">社会治安综合治理</div>
      </div>
    </div>


    <div class="text-center" style="width:100%;">
      <div>
        <img src="https://www.ccsht.cn/resources/static/images/tB.png" style="width:70vw;height:26vh;" >
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:20vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">报业</div>
        <div class="padding-bottom-xs ">智能全媒体数据中台</div>
        <div class="padding-bottom-xs ">传播影响力分析</div>
        <div class="padding-bottom-xs ">全媒体专题分析</div>
        <div class="padding-bottom-xs ">选题策划分析</div>
        <div class="padding-bottom-xs ">全媒体用户洞察与运营管理</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:14vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">出版</div>
        <div class="padding-bottom-xs ">大数据整合分析应用</div>
        <div class="padding-bottom-xs ">全渠道用户洞察分析</div>
        <div class="padding-bottom-xs ">智能知识识别与服务</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">泛销售</div>
        <div class="padding-bottom-xs ">数据中台</div>
        <div class="padding-bottom-xs ">经营分析与优化</div>
        <div class="padding-bottom-xs ">智能营销与运营</div>
        <div class="padding-bottom-xs ">销量预测与供应链优化</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">烟草</div>
        <div class="padding-bottom-xs ">烟草数据中台</div>
        <div class="padding-bottom-xs ">运营分析与领导驾驶舱</div>
        <div class="padding-bottom-xs ">零售户评价及巡检</div>
        <div class="padding-bottom-xs ">品规营销知识图谱</div>
      </div>

      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:14vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">地产</div>
        <div class="padding-bottom-xs ">地产数据中台</div>
        <div class="padding-bottom-xs ">经营分析与决策辅助</div>
        <div class="padding-bottom-xs ">全链路智能营销</div>
      </div>
    </div>
    <div class="text-center" style="width:100%;">
      <div>
        <img src="https://www.ccsht.cn/resources/static/images/ss.png" style="width:70vw;height:26vh;" >
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;	border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">舆情洞察</div>
        <div class="padding-bottom-xs ">品牌与竞品传播监测</div>
        <div class="padding-bottom-xs ">事件传播路径分析</div>
        <div class="padding-bottom-xs ">负面信息实时预警</div>
        <div class="padding-bottom-xs ">热点发现与趋势洞察</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">在线调查</div>
        <div class="padding-bottom-xs ">应急大数据治理</div>
        <div class="padding-bottom-xs ">危化品安全生产管理</div>
        <div class="padding-bottom-xs ">防汛防台预警预防</div>
        <div class="padding-bottom-xs ">智慧消防一体化平台</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">智慧环保</div>
        <div class="padding-bottom-xs ">3亿+用户购物行为触达和洞察</div>
        <div class="padding-bottom-xs ">400万+活跃在线调研样本库</div>
        <div class="padding-bottom-xs ">最专业的调查系统：乐调查</div>
        <div class="padding-bottom-xs ">区域生态环境动态管控</div>
      </div>
      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:17vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">智能移动办公学习平台</div>
        <div class="padding-bottom-xs ">即时通讯与音视频会议</div>
        <div class="padding-bottom-xs ">在线文档协作</div>
        <div class="padding-bottom-xs ">智能移动办公</div>
        <div class="padding-bottom-xs ">企业学习门户</div>
      </div>

      <div class="margin-left-xs margin-bottom-xs"  style="width:92vw;height:11vh;border: 3px dashed rgba(79,129,189);">
        <div class=" text-bold padding-top-xs padding-bottom-xs" style="color: rgba(79,129,189);">MobileQuest</div>
        <div class="padding-bottom-xs ">购物路径分析</div>
        <div class="padding-bottom-xs ">购物用户画像</div>
      </div>
    </div>
</div>
      </div>


   </div>
    <MobileFooter></MobileFooter>
  </div>
</template>

<script>
import MobileHeader from "../../components/MobileHeader";
import { global } from "../../utils/global";
import MobileFooter from "../../components/MobileFooter";

export default {
  name: "MobileSolution",
  components: { MobileFooter, MobileHeader },
  data() {
    return {
      index: 1,
      resourcePrefix: global.RESOURCE_PREFIX,
      solutionArray: [
        {
          title: '<span style="color: #ff4e00;">5G+</span>生态无人农场',
          img:
            "https://www.ccsht.cn/resources/static/images/01%E7%94%9F%E6%80%81%E6%97%A0%E4%BA%BA%E5%86%9C%E5%9C%BA.jpg",
          content:
            "是现代农艺和农机装备、绿色植保技术、无人机、机器人、人工智能、物联网、大数据、云计算、3S、5G等高新技术集成的成果，将依托各种传感器节点和网络，通过天、空、地一体化信息监测系统获取农情信息，采用地空一体化智能农业机器人和农业装备等协同作业，实现农业生产环境的智能感知、智能分析、智能决策、智能预警等功能，达到绿色生态农业生产的精准化种植，可视化管理和智能化操控，打造可复制易推广的绿色生态、高效环保的循环无人农场新模式。",
        },
        {
          title: "农业全过程无人作业",
          img:
            "https://www.ccsht.cn/resources/static/images/02%E5%86%9C%E4%B8%9A%E5%85%A8%E8%BF%87%E7%A8%8B%E6%97%A0%E4%BA%BA%E4%BD%9C%E4%B8%9A.jpg",
          content:
            "包括”耕、种、管、收”等全部农业生产环节，采用智能拖拉机、深翻机、播种机、旋耕机、水稻插秧机、打捆机、收割机、无人飞机、物联网传感器等装备对农业生产全过程进行无人化作业。",
        },
        {
          title: "无人驾驶整体技术解决方案",
          img:
            "https://www.ccsht.cn/resources/static/images/03%E6%97%A0%E4%BA%BA%E9%A9%BE%E9%A9%B6%E6%95%B4%E4%BD%93%E6%8A%80%E6%9C%AF%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.jpg",
          content:
            "公司具有专业的无人驾驶汽车的研发团队，能够提供从线控底盘、线控改制、自动驾驶算法、高精度语义地图构建、自动驾驶零部件、自动驾驶整车端到端一体化解决方案。无人驾驶车型包含小型乘用车、旅游",
        },
        {
          title: "智能行走装备云控平台",
          img:
            "https://www.ccsht.cn/resources/static/images/04%E6%99%BA%E8%83%BD%E8%A1%8C%E8%B5%B0%E8%A3%85%E5%A4%87%E4%BA%91%E6%8E%A7%E5%B9%B3%E5%8F%B0.jpg",
          content:
            "构建“车-路-云-网-法”协同的生态系统，支持“车-路-云-网-法”协同的智 能网联驾驶相关应用，并为智能网联汽车示范运营提供规范、可靠的服务管理支撑，保证无人驾驶车辆、设备 设施的安全可控。同时兼顾有人驾驶车辆、智能农机、渣土车和环卫车等行走装备的监控管理。",
        },
        {
          title: "智能装备应用研究",
          img:
            "https://www.ccsht.cn/resources/static/images/05%E6%99%BA%E8%83%BD%E8%A3%85%E5%A4%87%E5%BA%94%E7%94%A8%E7%A0%94%E7%A9%B6.jpg",
          content:
            "由国内顶尖院士领衔，联合（TIAA）国家车载信 息服务产业应用联盟及清华大学、吉林大学和吉林农业大学等科研院校，同步开展自动驾驶汽车、智能农机等智能装备的应用技术研发，并进行智能装 备应用推广工作。",
        },
        {
          title: "智慧景区一体化综合管控平台",
          img:
            "https://www.ccsht.cn/resources/static/images/09%E6%99%BA%E6%85%A7%E6%99%AF%E5%8C%BA%E4%B8%80%E4%BD%93%E5%8C%96%E7%BB%BC%E5%90%88%E7%AE%A1%E6%8E%A7%E5%B9%B3%E5%8F%B0.jpg",
          content:
            "通过景区一体化综合管控平台建设，实时监控旅游景区运行情况，实现景区流程化的生产运营、精细化的管理、精准化的营销决策、智能化的应急指挥以及人性化的游客服务，高效支撑领导决策，提升旅游突发事件应急管理能力。",
        },
      ],
      solutionArray1: [
        {
          title: "科大讯飞",
          isK: true,
          img:
            "https://www.ccsht.cn/resources/static/images/06%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9E.jpg",
          content:
            "三合通科技的战略投资合作伙伴之一，科大讯飞专业从事智能语音及语言技术研究、软件及芯片产品开发、语音信息服务及电子政务系统集成等 。在语音合成、语音识别、口语评测、语言翻译、声纹识别、人脸识别、自然语言处理等智能语音与人工智能核心技术上代表国际先进水平。",
        },
        {
          title: "北京百分点",
          isB: true,
          img:
            "https://www.ccsht.cn/resources/static/images/07%E5%8C%97%E4%BA%AC%E7%99%BE%E5%88%86%E7%82%B9.jpg",
          content:
            "三合通科技的战略投资合作伙伴之一，是国内大数据公司第一梯队的龙头企业，拥有完整的大数据和认知智能产品线，以及行业智能决策应用产品。目前已服务国内外10,000+企业与政府客户，致力于推进数据到知识再到智能决策的演进。",
        },
      ],
    };
  },
  methods: {
    click: function (index) {
      this.index = index;
    },
  },
};
</script>

<style scoped>
.pic {
  position: relative;
  float: left;
  height: auto;
  width: calc(25% - 5px);
  margin-right: 5px;
  margin-bottom: 5px;
  padding-bottom: 10px;
  padding-top: 10px;
  text-align: center;
  /*font-size: 30px;*/
  background-color: #f0f0f0;
}

.img {
  width: 60%;
  height: auto;
}

.text-xxl {
  font-size: 50px;
  text-align: center;
}

.title {
  font-size: 40px;
}

.content {
  font-size: 30px;
}

.hiden {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: grey;
}
.san1 {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 375px !important;
  left: 400px !important;
  z-index: 8888;
}

.business-content {
  color: grey;
  text-align: left;
  font-size: 16px;
  line-height: 24px;
  text-indent: 2em;
  /*text-justify: inter-ideograph;*/
}

.main-color {
  color: #ff4e00;
}
.title {
  width: 100%;
  display: inline-block;
}
.title1 {
  width: 50%;
  display: inline-block;
  font-size: 1.5rem;
  font-weight: bold;
}
.click {
  color: rgba(0, 129, 255);
}
.div{
    display:inline-block;
    width:43%;
    padding-right: .5rem;
    padding-bottom: .5rem;
}
.img{
    width: 100%;
    height: auto;
}
</style>
